const STATE = {
  SLIDINGBANNER: {
    OPEN: 'open',
    CLOSED: 'closed',
    DEFAULT: 'default',
  },

  // @see https://developers.google.com/youtube/iframe_api_reference#Playback_status
  YOUTUBE_PLAYER: {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    VIDEO_CUED: 5,
  },

  MEGAMENU: {
    CLOSED: 0,
    OPEN: 1,
  },
};

export default STATE;
